import { render, staticRenderFns } from "./UploadSidebar.vue?vue&type=template&id=732d3aef&scoped=true&"
import script from "./UploadSidebar.vue?vue&type=script&lang=js&"
export * from "./UploadSidebar.vue?vue&type=script&lang=js&"
import style0 from "./UploadSidebar.vue?vue&type=style&index=0&id=732d3aef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732d3aef",
  null
  
)

export default component.exports